import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../../lib/awardlist";
import { useNavigate } from 'react-router-dom'
import { ClassForLessonSelect, RecognitionLevelSelect, RankingSelect } from '../../../ui/myselect'

export default function AwardListEdit({ slug, Id, status }) {
	const [gradelevel, setGradelevel] = useState()
	const [recoglevel, setRecoglevel] = useState()
	const [sortOrder, setSortOrder] = useState(0)
	const [description, setDescription] = useState()
	const [data, setData] = useState([])
	const [ranking, setRanking] = useState('')

	const navigate = useNavigate()

	async function GetData() {
		const organizationData = await getIdData(Id)
		setData(organizationData)
		setDescription(organizationData[0].description)
		setGradelevel(organizationData[0].gradelevel)
		setRecoglevel(organizationData[0].recoglevel)
		setSortOrder(organizationData[0].sortorder)
		setRanking(organizationData[0].ranking || '')
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (status === 'Add') {
			await addData({
				studentId: slug,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				description: description,
				sortorder: sortOrder,
				ranking: ranking
			})
		} else {
			await updateData({
				id: Id,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				description: description,
				sortorder: sortOrder,
				ranking: ranking
			})
		}

		navigate(-1)
	}

	useEffect(() => {
		if (status === 'Update') {
			GetData()
		}
	}, [status])
	return (
		<div className="settings-widget profile-details">
			<div className="settings-menu p-4">
				<div className="profile-heading">
					<h3>{status === 'Add' ? 'Add Award' : 'Update Award'}</h3>
				</div>
				<div className="checkout-form personal-address add-course-info ">
					<form role="form" onSubmit={handleSubmit}>
						<div className="row mx-auto">
							<div className="col-9">
								<div className="form-group">
									<label className="form-control-label">Order</label>
									<input type="number" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="form-control" required />
								</div>
							</div>

							<div className="col-9">
								<div className="form-group">
									<label className="form-control-label">Grade Level</label>
									<ClassForLessonSelect value={gradelevel} name={'Grade Level'} setValue={setGradelevel} />
								</div>
							</div>

							<div className="col-9">
								<div className="form-group">
									<label className="form-control-label">Recognition Level</label>
									<RecognitionLevelSelect value={recoglevel} setValue={setRecoglevel} />
								</div>
							</div>

							<div className="col-9">
								<div className="form-group">
									<label className="form-control-label">Ranking</label>
									<RankingSelect value={ranking} setValue={setRanking} />
								</div>
							</div>

							<div className="col-9">
								<div className="form-group">
									<label className="form-control-label">Award</label>
									<textarea
										rows="4"
										value={description}
										onChange={(e) => setDescription(e.target.value)}
										className="form-control"
										placeholder="Award Description"
									></textarea>
								</div>
							</div>
							<div className="update-profile d-flex justify-content-between">
								<button type="submit" className="btn btn-primary">
									{status === 'Add' ? 'Add Award' : 'Update Award'}
								</button>
								<button onClick={() => navigate(`/instructor/instructor-studentawards/${slug}`)} className="btn btn-black btn-sm">
									Cancel
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}
